"use client";

import { isRichTextEmpty } from "@gettactic/helpers/src/workplace-requests/richText";
import React from "react";
import { RichTextBlock } from "./RichTextBlock";

interface InfoBlockCardProps {
  html: string | null | undefined;
}

/**
 * Admin prose as the employee sees it, in the flow of a request.
 *
 * Mounted twice on purpose — as an info block between a form's questions, and as
 * the whole body of a link type's terminal step — so the two mechanisms look
 * identical to the person reading them even though an admin configures them in
 * different places.
 *
 * A fill and a hairline, and nothing else: no callout, no accent border, no
 * icon. The body is admin prose of unpredictable length, and decoration makes a
 * long one unreadable while making every short one look urgent.
 *
 * An empty body renders nothing rather than an empty card.
 */
export const InfoBlockCard: React.FC<InfoBlockCardProps> = ({ html }) => {
  if (isRichTextEmpty(html)) {
    return null;
  }

  return (
    <div className="rounded-[10px] border border-neutral-100 bg-neutral-bg px-[13px] py-[11px]">
      <RichTextBlock html={html} />
    </div>
  );
};
